import { loadCompanyCensusEnv } from "@/env";
import { createApiClient } from "@cakewalk/frontend-api";
import type { CensusDraftWire, CensusDraftWriteRequest } from "./census-draft";

/**
 * Authenticated client for the company-census DRAFT (db-service source of truth,
 * reached through the platform-API proxy at `/api/quote-census/draft`).
 *
 * The platform API resolves the caller's tenant/email/org from the verified
 * Cognito session, so these calls send only the form payload — never identity.
 */

const DRAFT_PATH = "/api/quote-census/draft";

function baseUrl(): string {
  return loadCompanyCensusEnv().VITE_API_BASE_URL.replace(/\/$/, "");
}

function client() {
  return createApiClient({ baseUrl: baseUrl(), requireAuth: true });
}

/** Seed-on-login: returns the existing draft, or seeds one from operational data. */
export function ensureCensusDraft(): Promise<CensusDraftWire> {
  return client().post<CensusDraftWire>(`${DRAFT_PATH}/ensure`, {});
}

/** Read the live draft (resume / refresh). */
export function getCensusDraft(): Promise<CensusDraftWire> {
  return client().get<CensusDraftWire>(DRAFT_PATH);
}

/** Page-by-page save — stays a draft. */
export function saveCensusDraft(body: CensusDraftWriteRequest): Promise<CensusDraftWire> {
  return client().put<CensusDraftWire>(DRAFT_PATH, body);
}

/** Final submit — marks the draft complete. */
export function submitCensusDraft(body: CensusDraftWriteRequest): Promise<CensusDraftWire> {
  return client().post<CensusDraftWire>(`${DRAFT_PATH}/submit`, body);
}
